import {
    authRequest
} from "./auth";

import {
    ENDPOINT_CONGESTION_HISTORY,
    ENDPOINT_TURN_VIOLATIONS_COUNT, ENDPOINT_VIOLATIONS,
    ENDPOINT_VIOLATIONS_HISTORY
} from "../config";

import {
    eventSource
} from '../utils'
import * as Keys from '../config/componentKeys'
import { transformData } from "../dataTransformation";
import * as moment from 'moment'

export const FETCH_TRAFFIC_CONGESTION = "FETCH_TRAFFIC_CONGESTION";
export const FETCH_TRAFFIC_CONGESTION_SUCCESS = "FETCH_TRAFFIC_CONGESTION_SUCCESS";
export const FETCH_TRAFFIC_CONGESTION_MESSAGE = "FETCH_TRAFFIC_CONGESTION_MESSAGE";
export const FETCH_TRAFFIC_CONGESTION_FAILURE = "FETCH_TRAFFIC_CONGESTION_FAILURE";


export function fetchTrafficCongestion(key: string) {
    return (dispatch: Function) => {
        dispatch(sendTrafficCongestionRequest(key));

        eventSource.addEventListener("congestion-history", function (e) {
            // console.log(e);
            // @ts-ignore
            if (e && e.data) {
                // @ts-ignore
                const eventData = JSON.parse(e.data);
                const message = eventData.message;
                console.log('congestion-hostory', message);
                // const data = transformData(message, Keys.TRAFFIC_CONGESTION);

                dispatch({
                    type: FETCH_TRAFFIC_CONGESTION_MESSAGE,
                    payload: message,
                    meta: key
                })
            }
        })
    }
}

function sendTrafficCongestionRequest(key: string) {
    return async (dispatch: Function) => {
        try {
            // dispatch({
            //     type: FETCH_TRAFFIC_CONGESTION
            // })

            const toTimestamp = moment().utc().valueOf();
            let fromTimestamp = moment().startOf('day').utc().valueOf();

            switch (key) {
                case 'sixHours':
                    fromTimestamp = moment().subtract(6,"hours").utc().valueOf();
                    break;
                case 'twelveHours':
                    fromTimestamp = moment().subtract(12,"hours").utc().valueOf();
                    break;
                case 'allDay':
                    break;
                default:
                    fromTimestamp = moment().subtract(24,"hours").utc().valueOf();
                    break;
            }



            const response = await dispatch(
                authRequest(ENDPOINT_CONGESTION_HISTORY(fromTimestamp, toTimestamp, 3600000)));
            // console.log(response.data.data);

            if (response && response.data && response.data.data && response.data.data.results) {
                const result = response.data.data.results;

                const data = transformData(result, Keys.TRAFFIC_CONGESTION, key);

                dispatch({
                    type: FETCH_TRAFFIC_CONGESTION_SUCCESS,
                    payload: data,
                    meta: key
                })

            } else {
                dispatch({
                    type: FETCH_TRAFFIC_CONGESTION_FAILURE,
                    payload: {
                        message: 'Could not get the correct response'
                    },
                    meta: key
                })
            }

        } catch(error) {
            console.log(error);
            dispatch({
                type: FETCH_TRAFFIC_CONGESTION_FAILURE,
                payload: {
                    message: error
                },
                meta: key
            })

            // throw error
        }
    }
}

export const FETCH_RECENT_VIOLATIONS = "FETCH_RECENT_VIOLATIONS";
export const FETCH_RECENT_VIOLATIONS_SUCCESS = "FETCH_RECENT_VIOLATIONS_SUCCESS";
export const FETCH_RECENT_VIOLATIONS_MESSAGE = "FETCH_RECENT_VIOLATIONS_MESSAGE";
export const FETCH_RECENT_VIOLATIONS_FAILURE = "FETCH_RECENT_VIOLATIONS_FAILURE";

export function fetchRecentViolations() {
    return (dispatch: Function, getState: Function) => {
        dispatch(sendRecentViolationsRequest());

        eventSource.addEventListener("violations", function (e) {
            // console.log(e);
            // @ts-ignore
            if (e && e.data) {
                // @ts-ignore
                const eventData = JSON.parse(e.data);
                const message = eventData.message;
                const transformedMessage = transformData(message, Keys.RECENT_VIOLATIONS_EVENT);
                const state = getState();
                let {recentViolations} = state.dashboard
                let newRecentViolations = recentViolations.recentViolationsArray.reverse()
                newRecentViolations.push(transformedMessage);
                let newViolationsHistory = recentViolations.violationsHistory;
                let newRawData = recentViolations.rawData
                console.log(typeof transformedMessage)
                let data = {
                        violationsHistory: newViolationsHistory,
                        recentViolations: newRecentViolations,
                        rawData: newRawData
                }
                dispatch({
                    type: FETCH_RECENT_VIOLATIONS_SUCCESS,
                    payload: data
                })
            }
        })
    }
}

function sendRecentViolationsRequest() {
    return async (dispatch: Function) => {
        try {
            // dispatch({
            //     type: FETCH_RECENT_VIOLATIONS
            // })
            let toTimestamp = moment().utc().valueOf(); //for current time
            let fromTimestamp = moment.utc().subtract(1,"hours").valueOf();
            const response = await dispatch(authRequest(ENDPOINT_VIOLATIONS(fromTimestamp, toTimestamp, [] , 1000)));

            if (response && response.data && response.data.data && response.data.data.results) {
                const result = response.data.data.results;

                const data = transformData(result.reverse(), Keys.VIOLATIONS);

                dispatch({
                    type: FETCH_RECENT_VIOLATIONS_SUCCESS,
                    payload: data
                })

            } else {
                dispatch({
                    type: FETCH_RECENT_VIOLATIONS_FAILURE,
                    payload: {
                        message: 'Could not get the correct response'
                    }
                })
            }

        } catch(error) {
            console.log(error);
            dispatch({
                type: FETCH_RECENT_VIOLATIONS_FAILURE,
                payload: {
                    message: error
                }
            })

            // throw error
        }
    }
}

export const FETCH_TOTAL_VIOLATIONS = "FETCH_TOTAL_VIOLATIONS";
export const FETCH_TOTAL_VIOLATIONS_SUCCESS = "FETCH_TOTAL_VIOLATIONS_SUCCESS";
export const FETCH_TOTAL_VIOLATIONS_MESSAGE = "FETCH_TOTAL_VIOLATIONS_MESSAGE";
export const FETCH_TOTAL_VIOLATIONS_FAILURE = "FETCH_TOTAL_VIOLATIONS_FAILURE";

export function fetchTotalViolations() {
    return (dispatch: Function) => {
        dispatch(sendTotalViolationsRequest());

        eventSource.addEventListener("violations-history", function (e) {
            // console.log(e);
            // @ts-ignore
            if (e && e.data) {
                // @ts-ignore
                const eventData = JSON.parse(e.data);
                const message = eventData.message;
                console.log('violations-history', message);

                if (message
                    && message.hasOwnProperty('violations_count')
                    && message.hasOwnProperty('ts')) {

                    dispatch({
                        type: FETCH_TOTAL_VIOLATIONS_MESSAGE,
                        payload: message
                    })
                }
            }
        })
    }
}

function sendTotalViolationsRequest() {
    return async (dispatch: Function) => {
        try {
            // dispatch({
            //     type: FETCH_TOTAL_VIOLATIONS
            // })

            let toTimestamp = moment().utc().valueOf(); //for current time
            if(window.localStorage.getItem('camId') === "20190702T000035.mp4"){
                const date = moment([2019, 6, 2]);
                toTimestamp = moment(date).endOf('day').utc().valueOf();
            }
            // moment().endOf('day').utc().valueOf();
            let fromTimestamp = moment().startOf('day').utc().valueOf();
            if(window.localStorage.getItem('camId') === "20190702T000035.mp4"){
                const date = moment([2019, 6, 2]);
                fromTimestamp = moment(date).startOf('day').utc().valueOf();
            } else if(window.localStorage.getItem('camId') === "20190905T152044.mp4"){
                const date = moment([2019, 8, 5]);
                fromTimestamp = moment(date).startOf('day').utc().valueOf();
            } else if(window.localStorage.getItem('camId') === '20200106T015053.mp4'){
                const date = moment([2020, 1, 5]);
                fromTimestamp = moment(date).startOf('day').utc().valueOf();
            } else if(window.localStorage.getItem('camId') === 'gatso-cam'){
                const date = moment([2020, 1, 30]);
                fromTimestamp = moment(date).startOf('day').utc().valueOf();
            } else{
                const date = moment([2019, 1, 30]);
                fromTimestamp = moment(date).startOf('day').utc().valueOf();
            }

            const response = await dispatch(authRequest(ENDPOINT_VIOLATIONS_HISTORY(fromTimestamp, toTimestamp, 3600000)));

            if (response && response.data && response.data.data && response.data.data.results) {
                const result = response.data.data.results;

                const data = transformData(result, Keys.TOTAL_VIOLATIONS);

                dispatch({
                    type: FETCH_TOTAL_VIOLATIONS_SUCCESS,
                    payload: data
                })

            } else {
                dispatch({
                    type: FETCH_TOTAL_VIOLATIONS_FAILURE,
                    payload: {
                        message: 'Could not get the correct response'
                    }
                })
            }

        } catch(error) {
            console.log(error);
            dispatch({
                type: FETCH_TOTAL_VIOLATIONS_FAILURE,
                payload: {
                    message: error
                }
            })

            // throw error
        }
    }
}

export const FETCH_TRAFFIC_DETAILS = "FETCH_TRAFFIC_DETAILS";
export const FETCH_TRAFFIC_DETAILS_SUCCESS = "FETCH_TRAFFIC_DETAILS_SUCCESS";
export const FETCH_TRAFFIC_DETAILS_FAILURE = "FETCH_TRAFFIC_DETAILS_FAILURE";

export function fetchTrafficDetails() {
    return async (dispatch: Function) => {
        dispatch(sendTurnViolationsRequest());

        eventSource.addEventListener("turn-violation-counts", function (e) {
            // @ts-ignore
            if (e && e.data) {
                // @ts-ignore
                const eventData = JSON.parse(e.data);
                const message = eventData.message;
                console.log('turn-violation-counts', message);

                const data = transformData(message, Keys.TURN_VIOLATIONS);

                dispatch({
                    type: FETCH_TRAFFIC_DETAILS_SUCCESS,
                    payload: data
                })
            }
        })
    }
}

function sendTurnViolationsRequest(turnDirection?: string) {
    return async (dispatch: Function) => {
        try {
            // dispatch({
            //     type: FETCH_TRAFFIC_DETAILS
            // })

            const fromTimestamp = moment().startOf('day').utc().valueOf();
            const toTimestamp = moment().utc().valueOf(); //for current time

            const response = await dispatch(authRequest(ENDPOINT_TURN_VIOLATIONS_COUNT(fromTimestamp, toTimestamp, turnDirection)));
            // console.log(response.data.data);

            if (response && response.data && response.data.data && response.data.data) {
                const result = response.data.data;

                const data = transformData(result, Keys.TURN_VIOLATIONS);

                dispatch({
                    type: FETCH_TRAFFIC_DETAILS_SUCCESS,
                    payload: data
                })

            } else {
                dispatch({
                    type: FETCH_TRAFFIC_DETAILS_FAILURE,
                    payload: {
                        message: 'Could not get the correct response'
                    }
                })
            }

        } catch(error) {
            console.log(error);
            dispatch({
                type: FETCH_TRAFFIC_DETAILS_FAILURE,
                payload: {
                    message: error
                }
            })

            // throw error
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/dashboard.ts